import React, { useEffect, useRef, useState } from 'react';
import { ThunderboltFilled } from '@ant-design/icons';
import './index.less';

/**
 * 生成中占位卡
 * 参考豆包/千问：长方形渐变背景 + 左上角进度 + 流光动画
 *
 * Props:
 *  - count:  生成数量（1/2/4），决定显示几张占位卡
 *  - aspect: 占位卡宽高比，默认 1/1（视频可传 16/9）
 */
const GeneratingCard = ({ count = 1, aspect = '1/1' }) => {
  const [percent, setPercent] = useState(0);
  const timerRef = useRef(null);

  // 假进度：每 400ms 增加，前段快后段慢，到 99% 停下
  useEffect(() => {
    const start = Date.now();
    const tick = () => {
      const elapsed = (Date.now() - start) / 1000; // 秒
      // 0~10s 涨到 50%，10~30s 涨到 90%，30s+ 慢速逼近 99%
      let p = 0;
      if (elapsed < 10) {
        p = (elapsed / 10) * 50;
      } else if (elapsed < 30) {
        p = 50 + ((elapsed - 10) / 20) * 40;
      } else {
        p = 90 + Math.min(9, (elapsed - 30) / 6);
      }
      const next = Math.min(99, Math.floor(p));
      setPercent(next);
      timerRef.current = setTimeout(tick, 400);
    };
    timerRef.current = setTimeout(tick, 400);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  // 安全的 count
  const safeCount = [1, 2, 4].includes(count) ? count : 1;

  return (
    <div className={`generatingCard count-${safeCount}`}>
      {Array.from({ length: safeCount }).map((_, idx) => (
        <div
          key={idx}
          className="generatingItem"
          style={{ aspectRatio: aspect }}
        >
          {/* 渐变背景层 */}
          <div className="gradientLayer" />
          {/* 流光层 */}
          <div className="shimmerLayer" />
          {/* 左上角进度 */}
          <div className="progressBadge">
            <span className="progressDot" />
            <span className="progressText">{percent}%</span>
          </div>
          {/* 右下角状态文字 */}
          <div className="statusBadge">
            <ThunderboltFilled className="statusIcon" />
            <span>生成中</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GeneratingCard;
